import React from 'react';
import Svg, { Mask, Path, Rect, ClipPath, G, Defs } from 'react-native-svg';

export function HomeUnFilled({ width, height, color }) {
  return (
    <>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M2.24112 3.49112C2.47554 3.2567 2.79348 3.125 3.125 3.125H16.875C17.2065 3.125 17.5245 3.2567 17.7589 3.49112C17.9933 3.72554 18.125 4.04348 18.125 4.375V8.125C18.125 8.45652 17.9933 8.77446 17.7589 9.00888C17.5245 9.2433 17.2065 9.375 16.875 9.375H3.125C2.79348 9.375 2.47554 9.2433 2.24112 9.00888C2.0067 8.77446 1.875 8.45652 1.875 8.125V4.375C1.875 4.04348 2.0067 3.72554 2.24112 3.49112ZM2.24112 13.4911C2.47554 13.2567 2.79348 13.125 3.125 13.125H6.875C7.20652 13.125 7.52446 13.2567 7.75888 13.4911C7.9933 13.7255 8.125 14.0435 8.125 14.375V15.625C8.125 15.9565 7.9933 16.2745 7.75888 16.5089C7.52446 16.7433 7.20652 16.875 6.875 16.875H3.125C2.79348 16.875 2.47554 16.7433 2.24112 16.5089C2.0067 16.2745 1.875 15.9565 1.875 15.625V14.375C1.875 14.0435 2.0067 13.7255 2.24112 13.4911ZM12.2411 13.4911C12.4755 13.2567 12.7935 13.125 13.125 13.125H16.875C17.2065 13.125 17.5245 13.2567 17.7589 13.4911C17.9933 13.7255 18.125 14.0435 18.125 14.375V15.625C18.125 15.9565 17.9933 16.2745 17.7589 16.5089C17.5245 16.7433 17.2065 16.875 16.875 16.875H13.125C12.7935 16.875 12.4755 16.7433 12.2411 16.5089C12.0067 16.2745 11.875 15.9565 11.875 15.625V14.375C11.875 14.0435 12.0067 13.7255 12.2411 13.4911Z"
          stroke={color}
          strokeWidth="2"
        />
      </Svg>
    </>
  );
}
